import State from '../core/State';
import UserPersonalInformation from '../entity/UserPersonalInformation';
import initialState from '../initialState';

export const setUserPersonalInformation = (info: UserPersonalInformation) => (state: State): State => ({
  ...state,
  userPersonal: {
    personalInformation: info,
  },
});

export const disposeUserPersonal = () => (state: State): State => ({
  ...state,
  userPersonal: {
    ...initialState.userPersonal,
  },
});
